import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, createStyles, makeStyles, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { pxToRem } from '../../../theme';
import { formatDate } from '../../../utils';
import { UploadStatus } from '../../UploadStatus';
const formatNameTag = (fullName) => {
    const names = fullName
        .trim()
        .split(/\s+/)
        .map((name) => name.trim());
    const firstName = names[0] ? names[0][0].toUpperCase() : '';
    const lastName = names.length > 1 ? names[names.length - 1][0].toUpperCase() : '';
    return `${firstName}${lastName}`;
};
const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        paddingRight: theme.spacing(2),
    },
    conversation: {
        backgroundColor: theme.palette.brand.feather,
        borderRadius: 4,
        color: theme.palette.text.primary,
        padding: theme.spacing(1),
        width: 'max-content',
        '& p': {
            color: '#424242',
        },
    },
    icon: {
        alignItems: 'center',
        backgroundColor: theme.palette.primary.light,
        borderRadius: 32,
        color: theme.palette.primary.main,
        display: 'flex',
        flex: '0 0 32px',
        fontSize: pxToRem(14),
        fontWeight: 500,
        height: 32,
        justifyContent: 'center',
        marginTop: 23,
        width: 32,
    },
    system: {
        alignItems: 'flex-end',
    },
    systemUser: {
        backgroundColor: theme.palette.brand.sky50,
        '& p': {
            color: theme.palette.text.primary,
        },
    },
    time: {
        marginBottom: theme.spacing(0.5),
    },
    userName: {
        marginRight: theme.spacing(1),
        fontWeight: 500,
    },
    noteAttachment: {},
}));
export function ConversationItem({ conversation, profileUserId, onFileClick }) {
    const classes = useStyles();
    const formattedTime = formatDate(conversation.createdDate, 'MM/dd/yyyy h:mm a', false);
    const isUser = conversation.createdByUserId && profileUserId && conversation.createdByUserId !== profileUserId ? true : false;
    const nameTag = () => {
        return formatNameTag(conversation.userName || '');
    };
    return (_jsxs("div", { className: classes.root, children: [isUser && _jsx("div", { className: classes.icon, children: nameTag() }), _jsxs("div", { className: clsx(classes.content, { [classes.system]: !isUser }), children: [_jsxs(Typography, { className: classes.time, variant: 'body2', children: [isUser && _jsx("span", { className: classes.userName, children: conversation.userName }), _jsx(Typography, { color: 'textSecondary', component: 'span', variant: 'body2', children: formattedTime })] }), _jsxs("div", { className: clsx(classes.conversation, { [classes.systemUser]: !isUser }), children: [_jsx(Typography, { variant: 'body1', color: 'textPrimary', children: conversation.notes }), conversation.attachments &&
                                conversation.attachments?.length > 0 &&
                                conversation.attachments.map((f, i) => (_jsx(Box, { my: 1, children: _jsx(UploadStatus, { file: f.file, isUploaded: true, className: classes.noteAttachment, onClick: onFileClick }) }, i)))] })] })] }));
}
